import { render, staticRenderFns } from "./select-entity.vue?vue&type=template&id=b6f63b4e&scoped=true&"
import script from "./select-entity.vue?vue&type=script&lang=ts&"
export * from "./select-entity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f63b4e",
  null
  
)

export default component.exports